__turbopack_context__.v({
  "chooseMethodTitle": "index-module-scss-module__pJL_yq__chooseMethodTitle",
  "freeButton": "index-module-scss-module__pJL_yq__freeButton",
  "freeContinue": "index-module-scss-module__pJL_yq__freeContinue",
  "loading": "index-module-scss-module__pJL_yq__loading",
  "mainTitle": "index-module-scss-module__pJL_yq__mainTitle",
  "payment": "index-module-scss-module__pJL_yq__payment",
  "purchaseDetails": "index-module-scss-module__pJL_yq__purchaseDetails",
  "reduniq": "index-module-scss-module__pJL_yq__reduniq",
  "summaryBox": "index-module-scss-module__pJL_yq__summaryBox",
  "title": "index-module-scss-module__pJL_yq__title",
  "totalWrapper": "index-module-scss-module__pJL_yq__totalWrapper",
});
